import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.js'
import tdcompleteEn from './tdcomplete_en.js'
import getDomainAlias from '../domain.js'

Vue.use(VueI18n)

var locale = 'en'

const messages = {
  en: en
}

let programDomain = getDomainAlias()
if (programDomain === 'tdcomplete') {
  messages.en = tdcompleteEn
}

const i18n = new VueI18n({
  locale,
  silentFallbackWarn: true,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/assets/js/lang/lang.js